import React from 'react';
import Content from './Content';
import { HashRouter, Route, Switch as ReactSwitch } from 'react-router-dom';
import Faq from './Faq';
import Alert, { AlertType } from '../../Shared/components/Alert';
import Full from './Full';
import FullContent from './FullContent';
import Search from './Search';
const Switch = ({ viewType }) => {
    switch (viewType) {
        case 'content':
            return (React.createElement(HashRouter, { basename: "/" },
                React.createElement(ReactSwitch, null,
                    React.createElement(Route, { path: '/node/:id' },
                        React.createElement(Content, null)),
                    React.createElement(Route, { component: Content }),
                    ";")));
        case 'faq':
            return React.createElement(Faq, null);
        case 'full':
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "zds-row" },
                    React.createElement("div", { className: "default-content" },
                        React.createElement(Search, null))),
                React.createElement(HashRouter, { basename: "/" },
                    React.createElement(ReactSwitch, null,
                        React.createElement(Route, { path: '/node/:id' },
                            React.createElement("div", { className: "zds-row" },
                                React.createElement("div", { className: "default-content" },
                                    React.createElement(FullContent, null)))),
                        React.createElement(Route, null,
                            React.createElement("div", { className: "zds-row" },
                                React.createElement("div", { className: "no-indentation" },
                                    React.createElement(Full, null))))))));
        default:
            return React.createElement(Alert, { message: "viewType not available", type: AlertType.error });
    }
};
export default Switch;
